/**
 * When a kitchen screen may reload into a new build.
 *
 * Specification: ../test/update-rule.spec.ts.
 *
 * A reload blanks the board for a moment in front of somebody holding a pan,
 * so not during service. A queued bump waits for the server first. A ticket
 * left up overnight holds a fix back only for an hour.
 */

export function mayUpdateBoard(board: {
  readonly tickets: number;
  readonly queued: number;
  /** Since the screen was last touched. */
  readonly idleMs: number;
}): boolean {
  if (board.queued > 0) return false;
  return board.idleMs >= (board.tickets === 0 ? 2 * 60_000 : 60 * 60_000);
}
